import script from "./goodsDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./goodsDialog.vue?vue&type=script&setup=true&lang=js"

import "./goodsDialog.vue?vue&type=style&index=0&id=44305c27&scoped=true&lang=css"
import "./goodsDialog.vue?vue&type=style&index=1&id=44305c27&lang=css"

import exportComponent from "/Users/a1234/Documents/vue/vue3/demo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44305c27"]])

export default __exports__